<div
  [ngClass]="{
    warning: type === 'warn' || 'warn-soft',
    info: type === 'info',
    border: type !== 'warn-soft'
  }"
  class="container"
  >
  <div class="message">
    <mat-icon class="icon">
      {{ type === 'warn' ? 'warning' : 'info outline' }}
    </mat-icon>
    @if (statusTitle) {
      <span class="message--title">{{ statusTitle }}</span>
    }
    <span [ngClass]="{ noTitle: !statusTitle }">{{ statusText }}</span>
  </div>
  @if (actionTitle && actionCallback) {
    <div class="action">
      <a (click)="actionCallback()">{{ actionTitle }}</a>
    </div>
  }
</div>
